import {
  getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher,
  getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * トップバナーを削除するカスタムフック
 *
 * @param args.threeLetterCode - パートナーコード
 * @param args.topBannerId - トップバナーID
 * @param args.options - コールバックオプション
 * @param args.options.onSuccess - 成功時のコールバック
 * @param args.options.onError - エラー時のコールバック
 */
export const useDeletePartnerAdminsTopBanner = (
  threeLetterCode: string,
  topBannerId: number,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationKey(threeLetterCode, topBannerId),
    getDeleteApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationFetcher(
      threeLetterCode,
      topBannerId
    ),
    options
  );
};
